module.exports = __webpack_public_path__ + "static/logo-0e3030a3ad5f6feb354038ba29b44cc3.svg";